import { invoke3DSecureMethod } from './ui/3ds-method';
import { close3DSecureChallenge, invoke3DSecureChallenge } from './ui/3ds-challange';
import { ThreeDSecureStatus } from './@types/pay-requests';
import { ConnectPayClient } from './connect-pay-client';
import { PollingService } from './polling-service';

export class RequestHandler {
  constructor(
    private pollingService: PollingService,
    private connectPayClient: ConnectPayClient,
  ) {}

  public async handlePayCompletion(): Promise<boolean> {
    try {
      const initialStatusResponse = await this.pollingService.pollForAwaitingAuthenticationStatus();
      if (!initialStatusResponse) {
        return false;
      }

      const { threeDSecure } = initialStatusResponse;

      if (threeDSecure?.status === ThreeDSecureStatus.AWAITING_3DS_METHOD && threeDSecure.methodURL) {
        invoke3DSecureMethod(threeDSecure.methodURL);
        const methodStatusResponse = await this.pollingService.pollFor3DSecureMethodResult();
        if (!methodStatusResponse) {
          return false;
        }
      }

      await this.connectPayClient.send3DSecureAuthRequest();
      const authStatusResponse = await this.pollingService.pollFor3DSecureAuthResult();

      if (authStatusResponse?.threeDSecure?.status === ThreeDSecureStatus.AWAITING_CHALLENGE) {
        return this.handleChallengeFlow(authStatusResponse.threeDSecure.challengeURL);
      }
      return true;
    } catch (e) {
      console.error('handler failed:', e);
      return false;
    }
  }

  async handleChallengeFlow(challengeUrl?: string): Promise<boolean> {
    if (!challengeUrl) {
      console.log('no challange url');
      return false;
    }
    invoke3DSecureChallenge(challengeUrl);
    await this.pollingService.pollFor3DSecureChallengeResult();
    close3DSecureChallenge();
    return true;
  }
}
